import React from "react"
import Proptypes from "prop-types"
import { Row, Col } from "reactstrap"
import { Link } from "gatsby"

const EachDropdown = props => {
  return (
    <div className="each-dropdown">
      <div className="left">
        <p className="large-font">{props.title}</p>
      </div>
      <div className="right">
        {props.data.map(data => (
          <div className="each-dropdown-item">
            {!props.external ? (
              <Link to={data.link}>
                <Row className={!data.link ? "disabled" : ""}>
                  {data.icon ? (
                    <Col xs="3" sm="1" className="image">
                      <img
                        src={data.icon}
                        alt="Looking for a Jitsi Meet and WebRT development partner ? Contact Meetrix.IO"
                      ></img>
                    </Col>
                  ) : (
                    ""
                  )}
                  <Col xs="9" am="11" className="details">
                    <div>
                      <div className="title medium-font">{data.title}</div>
                      <div className="description small-font big-screen">
                        {data.description}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Link>
            ) : (
              <a
                href={data.link}
                target="_blank"
                rel="noopener"
                className={!data.link ? "disabled" : ""}
              >
                <Row>
                  {data.icon ? (
                    <Col xs="3" sm="1" className="image">
                      <img
                        src={data.icon}
                        alt="We provide world's best consultation and support for Jitsi Meet "
                      ></img>
                    </Col>
                  ) : (
                    ""
                  )}
                  <Col xs="9" am="11" className="details">
                    <div>
                      <div className="title medium-font">{data.title}</div>
                      <div className="description small-font big-screen">
                        {data.description}
                      </div>
                    </div>
                  </Col>
                </Row>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

EachDropdown.prototype = {
  data: Proptypes.any,
  image: Proptypes.any,
  title: Proptypes.any,
  description: Proptypes.any,
  link: Proptypes.any,
  external: Proptypes.any,
}

export default EachDropdown
